import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-white px-5 py-16 sm:py-24" aria-labelledby="bonuses-title" data-id="element-72" data-mp="av39r46tfp6f">
      <div className="mx-auto max-w-4xl" data-id="element-73" data-mp="at8t422kuj85">
        <p className="mx-auto flex w-fit items-center gap-2 rounded-full bg-alert px-4 py-1.5 text-sm font-bold uppercase tracking-wider text-white" data-id="element-74" data-mp="ft4pbf5196d5">
          <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-75" data-mp="1wrhkxqawjbv" />
          Exclusive bonuses — free today
        </p>
        <h2 id="bonuses-title" className="mt-5 text-center font-display text-4xl font-bold uppercase leading-tight text-navy-900 sm:text-5xl" data-id="element-76" data-mp="3o1lgyw505tlk">
          You'll also receive these 5 professional bonuses <span className="text-radar-deep" data-id="element-77" data-mp="1m9yv18zywovy">free</span>
        </h2>
        <p className="mt-4 text-center text-lg text-muted" data-id="element-78" data-mp="1m8fav7b6xtow">
          Total bonus value: <span className="font-semibold text-ink line-through decoration-alert" data-id="element-79" data-mp="1r78tfe5c4avx">$197</span> —{' '}
          <strong className="text-cta" data-id="element-80" data-mp="3icbunweqtxof">included FREE today</strong>
        </p>

        <div className="mt-12 space-y-14" data-id="element-81" data-mp="3detvgxqj2wtm">
          {bonuses.map(b => <article key={b.number} className="border-t border-navy-900/10 pt-10 first:border-t-0 first:pt-0" data-id="element-82" data-mp="3r702nubpdtgx">
              <div className="-mx-5 sm:mx-0" data-id="element-83" data-mp="3n6g3kl7kkfs5">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="w-full sm:rounded-3xl" loading="lazy" data-id="element-84" data-mp="2zfkf9y2bo2pn" />
              </div>
              <div className="mt-6 flex flex-wrap items-center gap-3" data-id="element-85" data-mp="38gil8lwbmkav">
                <span className="rounded-lg bg-alert px-3 py-1 font-display text-lg font-bold uppercase text-white" data-id="element-86" data-mp="33h5o98bqjwuk">
                  Bonus #{b.number}
                </span>
                <span className="text-base font-semibold text-muted" data-id="element-87" data-mp="ns4bqd4poebe">
                  Value: <span className="line-through decoration-alert" data-id="element-88" data-mp="iqex6nia5iik">${b.value}</span>{' '}
                  <span className="font-bold text-cta" data-id="element-89" data-mp="3ci4ufbjolfra">FREE</span>
                </span>
              </div>
              <h3 className="mt-3 font-display text-3xl font-bold uppercase leading-tight text-navy-900" data-id="element-90" data-mp="3hgoltrh1njr1">{b.title}</h3>
              <p className="mt-3 text-lg leading-relaxed text-ink" data-id="element-91" data-mp="3lke7a82f9l7u">{b.description}</p>

              {b.list && <>
                  <p className="mt-4 font-semibold text-ink" data-id="element-92" data-mp="2tsotin433lac">{b.listIntro}</p>
                  <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-93" data-mp="2tqltrbd4qdsf">
                    {b.list.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-94" data-mp="32td8pl57rrot">
                        <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-radar-deep" strokeWidth={3} aria-hidden="true" data-id="element-95" data-mp="32r0jqo11gh29" />
                        <span className="text-[16px] font-medium text-ink" data-id="element-96" data-mp="2a4pfn3e83y0p">{item}</span>
                      </li>)}
                  </ul>
                </>}

              {b.tagline && <p className="mt-5 rounded-xl bg-navy-900 p-4 text-[16px] font-semibold leading-relaxed text-white" data-id="element-97" data-mp="27k9jr2l07qbt">
                  {b.tagline}
                </p>}
            </article>)}
        </div>

        <SectionCta label="Yes! I want the 5 free bonuses" data-id="element-98" data-mp="1xk91zl2s9i9q" />
      </div>
    </section>;
}